import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 417,
  bgcolor: "background.paper",
  p: 2,
  height: "100vh",
};

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <div
        className="anotherVendorsReturn"
        onClick={() => {
          setOpen(true);
        }}
      >
        شرایط مرجوعی
        <img
          className="anotherVendorsNameLogo"
          src="/public/assets/icons/3d-rotate.svg"
          alt="pic"
        />
        <img src="/public/assets/icons/anotherVendors.svg" alt="فروشگاه" />
      </div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="ReturnTerms">
              <div className="HeadReturn">
                <span>شرایط مرجوعی</span>
                <span
                  onClick={() => {
                    setOpen(false);
                  }}
                  className="returnTermExit"
                >
                  &times;
                </span>
              </div>
              <p>
                {props.return_condition
                  ? props.return_condition
                  : "شرایطی برای مرجوعی وجود ندارد"}
              </p>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
